<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.5 5h-9a2 2 0 00-2 2v18a2 2 0 002 2h9a2 2 0 002-2V7a2 2 0 00-2-2zm-9 2h9v14h-9zm0 18v-3h9v3z"/><path d="M16.5 23h-1a.5.5 0 000 1h1a.5.5 0 000-1z"/></svg>